import { useCallback, useSyncExternalStore } from 'react';

function subscribe(onStoreChange: () => void) {
  window.addEventListener('popstate', onStoreChange);
  return () => window.removeEventListener('popstate', onStoreChange);
}

function getSnapshot(): string {
  return window.location.search;
}

type SearchParamsInit = URLSearchParams | Record<string, string> | ((prev: URLSearchParams) => URLSearchParams);

export function useSearchParams(): [URLSearchParams, (next: SearchParamsInit, options?: { replace?: boolean }) => void] {
  const search = useSyncExternalStore(subscribe, getSnapshot);
  const searchParams = new URLSearchParams(search);

  const setSearchParams = useCallback((next: SearchParamsInit, options?: { replace?: boolean }) => {
    const nextParams = typeof next === 'function' ? next(new URLSearchParams(window.location.search)) : new URLSearchParams(next);
    const query = nextParams.toString();
    const url = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;

    if (options?.replace) {
      window.history.replaceState({}, '', url);
    } else {
      window.history.pushState({}, '', url);
    }
    window.dispatchEvent(new PopStateEvent('popstate'));
  }, []);

  return [searchParams, setSearchParams];
}
